// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FontSizeOutlinedSvg from "@ant-design/icons-svg/es/asn/FontSizeOutlined";
import AntdIcon from '../components/AntdIcon';

var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FontSizeOutlinedSvg
  }));
};

FontSizeOutlined.displayName = 'FontSizeOutlined';
export default React.forwardRef(FontSizeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FontSizeOutlined.js
// module id = 1209
// module chunks = 0